const supabaseSymbol = Symbol("supabase");
export default supabaseSymbol;
//# sourceMappingURL=symbol.js.map